
import { defineComponent, PropType, ref } from 'vue'
import Item from '@/types/singleItem'

export default defineComponent({
  props: {
    title: {
      type: String as PropType<string>,
      required: true
    },
    list: {
      type: Array as PropType<Item[]>,
      required: true
    }
  },
  setup() {
    const visible = ref(false)
    const toggleVisible = () => visible.value = !visible.value
    
    return {
      toggleVisible,
      visible
    }
  }
})
